import axiosInstance from '../../../api/AxiosInstance';
import { endpoints } from '../../../services/endpoints';
import { addToCartRequest, addToCartRequestError, addToCartRequestSuccess } from '../../slices/Cart/AddToCartSlice';

export const AddToCartAPI = (data) => {

    return async (dispatch) => {
        try {
            dispatch(addToCartRequest());
            // Returning the promise so we can await it in handleSubmit
            const response = await axiosInstance({
                method: "POST",
                url: endpoints.addToCart,
                data: data,
            })
            return dispatch(addToCartRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(addToCartRequestError(_error));
        }
    };
};
